
<div class="split-page">

  <header class="page-header">
    <div>
      <span class="eyebrow">GERENCIAMENTO</span>
      <h1>Split de Pagamentos</h1>
      <p>Gerencie os recebedores e os repasses de cada hospedagem.</p>
    </div>

    <button
      type="button"
      class="btn btn-primary"
      (click)="abrirNovoRecebedor()">
      <span class="btn-plus">+</span>
      Novo recebedor
    </button>
  </header>

  <!-- INDICADORES -->
  <section class="stats-grid">

    <div class="stat-card">
      <span class="stat-label">Total de recebedores</span>
      <strong>{{ recebedores.length }}</strong>
      <span class="stat-detail">Cadastrados na plataforma</span>
    </div>

    <div class="stat-card">
      <span class="stat-label">Recebedores ativos</span>
      <strong>{{ totalAtivos }}</strong>
      <span class="stat-detail">Habilitados para novas cobranças</span>
    </div>

    <div class="stat-card">
      <span class="stat-label">Recebedores inativos</span>
      <strong>{{ totalInativos }}</strong>
      <span class="stat-detail">Sem novos repasses</span>
    </div>

  </section>

  <!-- LISTAGEM -->
  <section class="content-card">

    <div class="section-header">
      <div>
        <h2>Recebedores</h2>
        <p>Consulte e configure os participantes do split.</p>
      </div>

      <div class="search-box">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8">
          <circle cx="11" cy="11" r="7"></circle>
          <path d="m20 20-4-4"></path>
        </svg>

        <input
          type="search"
          placeholder="Buscar recebedor..."
          [(ngModel)]="busca"
          aria-label="Buscar recebedor">
      </div>
    </div>

    <div *ngIf="carregando" class="empty-state">
      Carregando recebedores...
    </div>

    <div
      *ngIf="!carregando && recebedoresFiltrados.length === 0"
      class="empty-state">

      <div class="empty-icon">◎</div>

      <h3>Nenhum recebedor encontrado</h3>

      <p>
        Cadastre um recebedor para começar a configurar
        os repasses das hospedagens.
      </p>
    </div>

    <div
      class="table-scroll"
      *ngIf="!carregando && recebedoresFiltrados.length > 0">

      <table class="split-table">
        <thead>
        <tr>
          <th>Recebedor</th>
          <th>Wallet ID</th>
          <th>Status</th>
          <th class="actions-column">Ações</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let recebedor of recebedoresFiltrados">

          <td>
            <div class="person-cell">
              <div class="avatar">
                {{ recebedor.nome.charAt(0).toUpperCase() }}
              </div>

              <div>
                <strong>{{ recebedor.nome }}</strong>
                <small>Recebedor #{{ recebedor.id }}</small>
              </div>
            </div>
          </td>

          <td>
              <span class="wallet-code">
                {{ recebedor.walletId }}
              </span>
          </td>

          <td>
              <span
                class="status-badge"
                [class.active]="recebedor.ativo"
                [class.inactive]="!recebedor.ativo">

                <span class="status-dot"></span>

                {{ recebedor.ativo ? 'Ativo' : 'Inativo' }}
              </span>
          </td>

          <td>
            <div class="table-actions">

              <button
                type="button"
                class="action-btn action-main"
                (click)="abrirRegras(recebedor)">
                Regras
              </button>

              <button
                type="button"
                class="action-btn"
                (click)="abrirEditarRecebedor(recebedor)">
                Editar
              </button>

              <button
                type="button"
                class="action-btn"
                [class.danger]="recebedor.ativo"
                (click)="alterarStatusRecebedor(recebedor)">
                {{ recebedor.ativo ? 'Desativar' : 'Ativar' }}
              </button>

            </div>
          </td>

        </tr>
        </tbody>
      </table>
    </div>
  </section>

</div>


<!-- MODAL RECEBEDOR -->
<div
  class="modal-overlay"
  *ngIf="modalRecebedorAberto"
  (click)="fecharModalRecebedor()">

  <div
    class="modal-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="titulo-recebedor"
    (click)="$event.stopPropagation()">

    <div class="modal-header">
      <div>
        <span class="eyebrow">RECEBEDOR</span>

        <h2 id="titulo-recebedor">
          {{ recebedorEditando ? 'Editar recebedor' : 'Novo recebedor' }}
        </h2>

        <p>Informe os dados da conta que receberá o repasse.</p>
      </div>

      <button
        type="button"
        class="close-btn"
        aria-label="Fechar"
        (click)="fecharModalRecebedor()">
        ×
      </button>
    </div>

    <form (ngSubmit)="salvarRecebedor()" #formRecebedor="ngForm">

      <div class="modal-body">

        <div class="form-field">
          <label for="nomeRecebedor">Nome do recebedor *</label>

          <input
            id="nomeRecebedor"
            name="nome"
            type="text"
            maxlength="150"
            required
            [(ngModel)]="formulario.nome"
            placeholder="Ex.: João Silva">
        </div>

        <div class="form-field">
          <label for="walletId">Wallet ID do Asaas *</label>

          <input
            id="walletId"
            name="walletId"
            type="text"
            maxlength="100"
            required
            [(ngModel)]="formulario.walletId"
            placeholder="Informe o identificador da carteira">

          <small>
            O recebedor precisa possuir uma conta Asaas
            com uma carteira válida.
          </small>
        </div>

        <label class="switch-row">
          <div>
            <strong>Recebedor ativo</strong>
            <small>Permitir utilização nas próximas cobranças.</small>
          </div>

          <input
            type="checkbox"
            name="ativo"
            [(ngModel)]="formulario.ativo">
        </label>

      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="salvando"
          (click)="fecharModalRecebedor()">
          Cancelar
        </button>

        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="salvando || formRecebedor.invalid">
          {{ salvando ? 'Salvando...' : 'Salvar recebedor' }}
        </button>
      </div>

    </form>
  </div>
</div>


<!-- MODAL REGRAS -->
<div
  class="modal-overlay"
  *ngIf="modalRegrasAberto"
  (click)="fecharModalRegras()">

  <div
    class="modal-panel modal-large"
    role="dialog"
    aria-modal="true"
    aria-labelledby="titulo-regras"
    (click)="$event.stopPropagation()">

    <div class="modal-header">
      <div>
        <span class="eyebrow">CONFIGURAÇÃO DE REPASSES</span>

        <h2 id="titulo-regras">Regras por hospedagem</h2>

        <p>
          Recebedor:
          <strong>{{ recebedorSelecionado?.nome }}</strong>
        </p>
      </div>

      <button
        type="button"
        class="close-btn"
        aria-label="Fechar"
        (click)="fecharModalRegras()">
        ×
      </button>
    </div>

    <div class="modal-body">

      <div class="info-banner">
        Configure quanto este recebedor deverá receber
        em cada hospedagem. As alterações serão utilizadas
        nas novas cobranças.
      </div>

      <div *ngIf="carregandoRegras" class="empty-state">
        Carregando regras...
      </div>

      <div
        *ngIf="!carregandoRegras && hospedagens.length === 0"
        class="empty-state">
        <h3>Hospedagens não configuradas</h3>
        <p>
          Informe os IDs reais das hospedagens no componente
          antes de cadastrar regras de split.
        </p>
      </div>

      <div
        class="rules-list"
        *ngIf="!carregandoRegras && hospedagens.length > 0">

        <div
          class="rule-card"
          *ngFor="let regra of regrasFormulario">

          <div class="rule-heading">
            <div>
              <h3>{{ nomeHospedagem(regra.hospedagemId) }}</h3>
              <p>
                {{ regra.ativo ? 'Repasse habilitado' : 'Repasse desativado' }}
              </p>
            </div>

            <label class="toggle-control">
              <input
                type="checkbox"
                [(ngModel)]="regra.ativo"
                [name]="'ativo_' + regra.hospedagemId">

              <span>
                {{ regra.ativo ? 'Ativo' : 'Inativo' }}
              </span>
            </label>
          </div>

          <div class="rule-fields" *ngIf="regra.ativo">

            <div class="form-field">
              <label>Tipo de repasse</label>

              <select
                [(ngModel)]="regra.tipo"
                [name]="'tipo_' + regra.hospedagemId">

                <option value="PERCENTUAL">
                  Percentual (%)
                </option>

                <option value="FIXO">
                  Valor fixo (R$)
                </option>

              </select>
            </div>

            <div class="form-field">
              <label>
                {{ regra.tipo === 'PERCENTUAL'
                ? 'Percentual (%)'
                : 'Valor por cobrança (R$)' }}
              </label>

              <input
                type="number"
                min="0.01"
                [max]="regra.tipo === 'PERCENTUAL' ? 100 : null"
                [step]="regra.tipo === 'PERCENTUAL' ? 0.01 : 0.01"
                [(ngModel)]="regra.valor"
                [name]="'valor_' + regra.hospedagemId"
                placeholder="0,00">
            </div>

          </div>

          <div class="rule-note" *ngIf="regra.ativo">
            <ng-container *ngIf="regra.tipo === 'PERCENTUAL'">
              O percentual será calculado conforme o valor
              líquido considerado pelo Asaas.
            </ng-container>

            <ng-container *ngIf="regra.tipo === 'FIXO'">
              O valor fixo será aplicado à cobrança,
              respeitando o parcelamento e as regras do gateway.
            </ng-container>
          </div>

        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        [disabled]="salvando"
        (click)="fecharModalRegras()">
        Cancelar
      </button>

      <button
        type="button"
        class="btn btn-primary"
        [disabled]="salvando || carregandoRegras || !hospedagens.length"
        (click)="salvarRegras()">
        {{ salvando ? 'Salvando...' : 'Salvar regras' }}
      </button>
    </div>

  </div>
</div>
